var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('span',{attrs:{"data":_vm.paidstatus}},[_vm._v("Status: "+_vm._s(_vm.paidstatus))]),_c('br'),_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])}
var staticRenderFns = []

export { render, staticRenderFns }